import { render, staticRenderFns } from "./ReportesLiquidacionesResumen.vue?vue&type=template&id=a076564c&"
import script from "./ReportesLiquidacionesResumen.vue?vue&type=script&lang=js&"
export * from "./ReportesLiquidacionesResumen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports